var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBoards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22730_3589)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.8798 30.75H21.3698L20.3198 36H42.9298L41.8798 30.75Z",
    fill: "url(#paint0_linear_22730_3589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.75 22H18.5V25.5H44.75V22Z",
    fill: "url(#paint1_linear_22730_3589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 44.75H44.75V39.5H46.5V36L44.75 27.25H18.5L16.75 36V39.5H18.5V50H34.25V39.5H41.25V44.75ZM30.75 46.5H22V39.5H30.75V46.5ZM20.32 36L21.37 30.75H41.88L42.93 36H20.32Z",
    fill: "url(#paint2_linear_22730_3589)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 46.5V41.25H46.5V46.5H41.25V50H46.5V55.25H50V50H55.25V46.5H50Z",
    fill: "url(#paint3_linear_22730_3589)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22730_3589",
    x1: 20.3198,
    y1: 33.375,
    x2: 42.9298,
    y2: 33.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22730_3589",
    x1: 18.5,
    y1: 23.75,
    x2: 44.75,
    y2: 23.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22730_3589",
    x1: 16.75,
    y1: 38.625,
    x2: 46.5,
    y2: 38.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22730_3589",
    x1: 41.25,
    y1: 48.25,
    x2: 55.25,
    y2: 48.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22730_3589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBoards);
export default __webpack_public_path__ + "static/media/add_boards.d5d1791c5a9998fbc979a4650970a9a9.svg";
export { ForwardRef as ReactComponent };